<template>
  <div class="blocks">
    <div>最终用户协议</div>
    <p class="subTitle">一、软件使用协议</p>
    <p class="subTitle">1.协议的法律约束性</p>
    <p>本协议是用户（自然人、法人或社会团体）与中世康恺科技有限公司关于中世康恺数字影像云平台（以下简称“本软件产品”）的法律协议。一旦用户安装、复制或以其他方式使用本软件产品，或通过点击“健康咨询”按钮等方式使用本软件提供的任何服务，即表示用户同意接受本协议各项条件的约束。如果用户不同意本协议的任何条款，请不要使用本软件产品或其任何服务。</p>

    <p class="subTitle">2.用户信息收集与授权</p>
    <p>用户在使用本软件产品过程中，为完成账号注册、身份验证、健康咨询及相关服务，需向中世康恺科技有限公司提供如下个人信息：</p>
    <p>1）个人基本信息：包括但不限于手机号码、身份证号码；</p>
    <p>2）健康相关信息：包括但不限于检查信息、诊断报告、病史资料等；</p>
    <p>3）服务过程中产生的其他信息：包括咨询内容、交互记录等。</p>
    <p>用户点击“健康咨询”按钮或使用本软件相关功能，即表示明确同意并授权中世康恺科技有限公司在以下目的范围内收集、存储、使用及处理其个人信息：</p>
    <p>1）为用户创建并管理账号；</p>
    <p>2）提供健康咨询、诊断建议及相关服务；</p>
    <p>3）进行用户身份识别与验证；</p>
    <p>4）保障服务过程的安全性与合规性；</p>
    <p>5）法律法规允许的其他与本服务相关的用途。</p>
    <p>中世康恺科技有限公司承诺将严格按照《中华人民共和国个人信息保护法》等相关法律法规的规定，采取必要的技术和管理措施，保护用户个人信息
的安全，未经用户同意，不会向任何第三方泄露其个人信息，除非法律法规另有规定或用户另行授权。</p>
<p class="subTitle">3.匿名化数据应用与处理</p>
<p>为提升医疗健康服务质量、促进医学研究、进行产品优化及开展公共健康目的之数据分析，中世康恺科技有限公司将对用户个人信息进行匿名化处理。匿名化处理是指通过对个人信息的技术处理，使得个人信息无法识别特定个人且不能被复原的过程。</p>
<p>数据处理目的：经匿名化处理后的数据将用于包括但不限于：</p>
<p>1)医学研究与统计分析；</p>
<p>2)机器学习模型训练与算法优化；</p>
<p>3)产品功能与服务质量的改进；</p>
<p>4)形成不识别您个人的群体健康趋势报告。</p>
<p>数据性质与使用：此类匿名化数据已不再属于法律定义的个人信息，中世康恺科技有限公司有权在不另行通知您或取得您同意的情况下，对上述匿名化数据进行存储、分析、使用和与第三方共享。</p>
<p>法律依据与承诺：我们承诺将严格遵守相关技术标准，确保匿名化过程的有效性和不可逆性，并采取必要的安全措施保护匿名化数据集的安全。此等处理活动将完全符合《中华人民共和国个人信息保护法》关于个人信息匿名化的规定。</p>
<p class="subTitle">4.诊断结果的参考性</p>
    <p>本软件产品提供的专家诊断结果仅供参考，用户不应将其作为最终诊断依据。</p>
    <p>用户在使用诊断结果时应咨询专业医疗人员的意见。</p>

    <p class="subTitle">二、软件产品保护条款</p>
    <p class="subTitle">1.知识产权归属</p>
    <p>本软件产品的著作权及其他知识产权（包括但不限于著作权、专利权、商标权、商业秘密等）均归中世康恺科技有限公司所有。本软件产品受中华人民共和国版权法及国际版权条约和其他知识产权法及条约的保护。用户仅获得本软件产品的非排他性使用权。</p>
    <p class="subTitle">2.禁止性行为</p>
    <p>用户不得删除本软件及其他副本上的一切关于版权的信息，不得对本软件进
    行反向工程（如反汇编、反编译等）。</p>
    <p class="subTitle">3.软件的现状提供</p>
    <p>本软件产品以“现状”方式提供，中世康恺科技有限公司不保证本软件产品
    能够完全满足用户需求。用户手册、帮助文件、使用说明书等软件文档中的
    介绍性内容仅供用户参考，不应视为对用户的任何承诺。中世康恺科技有限
    公司保留对软件版本进行升级，以及对功能、内容、结构、界面、运行方式
    等进行修改和自动更新的权利。</p>
    <p class="subTitle">4.信息收集与隐私保护</p>
    <p>为了更好地服务用户，本软件产品可能会收集某些信息。用户点击“服务咨询”按钮或使用本软件的任何功能，即视为用户同意授权中世康恺科技有限</p>
    <p>公司收集和使用其个人数据。</p>
    <p class="subTitle">5.风险承担与责任限制</p>
    <p>使用本软件产品由用户自行承担风险。在适用法律允许的最大范围内，中世
    康恺科技有限公司在任何情况下不就因使用或不能使用本软件产品所发生
    的特殊的、意外的、非直接或间接的损失承担赔偿责任，即使已事先被告知
    该损害发生的可能性。</p>
    <p class="subTitle">6.信息内容保护</p>
    <p>中世康恺科技有限公司定义的信息内容（包括文字、软件、声音、商业信息
    等）受版权、商标权、其他知识产权和所有权法律的保护。用户只能在本公
    司授权下使用这些内容，不得擅自复制、修改、编撰或创造与内容有关的衍
    生产品。</p>
    <p class="subTitle">7.违约责任</p>
    <p>如果用户未遵守本协议的任何条款，中世康恺科技有限公司有权立即终止本
    协议，并保留通过法律手段追究用户责任的权利。</p>
    <p class="subTitle">8.协议的解释与修改</p>
    <p>中世康恺科技有限公司具有对本协议条款内容的最终解释权和修改权。如果
    用户对中世康恺科技有限公司的解释或修改有异议，应当立即停止使用本软
    件产品。用户继续使用本软件产品的行为将被视为对中世康恺科技有限公司
    的解释和修改的接受。</p>
    <div style="height:50px"></div>
  </div>
</template>
<script>
import { Toast } from 'vant'
export default {
  props: ['patientList'],
  data() {
    return {}
  },
  methods: {
   
  }
}
</script>
<style scoped lang="scss">
blocks::-webkit-scrollbar {
  display: none;
}
.blocks {
   /* width: 80%; */
  height: 100%;
  border-radius: 10px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
.blocks div {
  font-size: 14px;
  text-align: center;
  font-weight: bold;
}
.blocks p {
  text-align: left;
  text-indent: 2em;
}
.blocks .subTitle {
  font-weight: bold;
}
</style>


